/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrendPoint
 */
export interface TrendPoint {
    /**
     * 
     * @type {Date}
     * @memberof TrendPoint
     */
    at?: Date;
    /**
     * 
     * @type {number}
     * @memberof TrendPoint
     */
    value?: number;
}

/**
 * Check if a given object implements the TrendPoint interface.
 */
export function instanceOfTrendPoint(value: object): value is TrendPoint {
    return true;
}

export function TrendPointFromJSON(json: any): TrendPoint {
    return TrendPointFromJSONTyped(json, false);
}

export function TrendPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'at': json['at'] == null ? undefined : (new Date(json['at'])),
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function TrendPointToJSON(json: any): TrendPoint {
    return TrendPointToJSONTyped(json, false);
}

export function TrendPointToJSONTyped(value?: TrendPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'at': value['at'] == null ? undefined : ((value['at']).toISOString()),
        'value': value['value'],
    };
}

